module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace8_notte-55dbd9bcbb38527f2629667a49429e70.jpg";